<h3>{{ '_Report_Lobby_Export_' | translate }}</h3>

<div class="cc-content-wrapper lobby-data-view-wrapper">
  <div class="cc-single-tab">

    <form class="form-horizontal" [formGroup]="dataViewForm">
      <div class="row cc-action-panel align-items-start">
        <div class="cc-filters align-items-start">
          <!-- Data Views -->
          <div class="me-3">
            <label>{{'_General_Report_Title_Text_' | translate}}</label>
            <select #filterList id="filterList" class="cc-select-dropdown filter-list form-control" placeholder="'_General_Select_Text_' | translate"
                    formControlName="dataView">
              <option *ngFor="let dataView of dataViews" [ngValue]="dataView.id">
                {{dataView.name}}
              </option>
            </select>
          </div>
          <!-- Locations -->
          <div class="me-3">
            <label>{{ '_General_Locations_Text_' | translate }}</label>
            <ng-multiselect-dropdown class="location-selector" formControlName="locations" [placeholder]="(commonData.locations.length == 0)? ('_General_No_Branches_Text_' | translate) : ('_General_Select_Text_' | translate)"
                                      [settings]="locationDropdownSettings" [data]="commonData.locations"
                                      [disabled]="commonData.locations.length == 0"></ng-multiselect-dropdown>
          </div>
        </div>
        <div class="cc-filters ms-3 align-items-end">
           <!-- From -->
          <div class="me-2">
            <label>{{ '_General_From_Text_' | translate }}</label>
            <kendo-datepicker class="date-picker"
                              formControlName="from"
                              [navigation]="false"
                              [readOnlyInput]="true"
                              (valueChange)="fromDateChange()">
              <kendo-datepicker-messages today="{{ '_General_Today_Text_' | translate }}"
                                          toggle="{{ '_General_Toggle_Calendar_Text_' | translate }}">
              </kendo-datepicker-messages>
            </kendo-datepicker>
          </div>
          <!-- To -->
          <div class="me-2">
            <label>{{ '_General_To_Text_' | translate }}</label>
            <kendo-datepicker class="date-picker"
                              formControlName="to"
                              [navigation]="false"
                              [readOnlyInput]="true"
                              (valueChange)="toDateChange()">
              <kendo-datepicker-messages today="{{ '_General_Today_Text_' | translate }}"
                                          toggle="{{ '_General_Toggle_Calendar_Text_' | translate }}">
              </kendo-datepicker-messages>
            </kendo-datepicker>
          </div>
          <div class="d-flex mt-3">
            <!-- Buttons -->
            <div class="me-2">
              <button type="button" class="btn btn-primary" (click)="runReport()">
                {{ '_Report_Lobby_Run_Report_Text_' | translate }}
              </button>
            </div>
            <div>
              <button type="button" class="btn btn-primary ms-auto" (click)="exportToCsv()">
                <!-- Optional: <kendo-button icon="csv"> or font-awesome icon -->
                {{ '_Report_Lobby_Export_Text_' | translate }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>
    <div class="initial-loading-prompt col-md-12" *ngIf="isLoading">
      <label id="loadingPrompt" class="loading-prompt" *ngIf="isLoading">{{loadingPrompt}}</label>
    </div>

    <div class="lobby-dataview-grid">
      <kendo-grid #grid="kendoGrid"
                  [data]="gridData"
                  [pageSize]="pageSize"
                  [resizable]="true"
                  [skip]="skip"
                  [sort]="sort"
                  [sortable]="{ allowUnsort: false, mode: 'single' }"
                  [pageable]="{ pageSizes: [10, 20, 30, 50, 100] }"
                  (pageChange)="pageChange($event)"
                  (sortChange)="sortChange($event)">
        <a href="lobby-data-view.component.html">lobby-data-view.component.html</a>
        <kendo-grid-column *ngFor="let col of columns" [field]="col.field" [title]="col.title" [width]="col.width" [sortable]="col.sortable">
        </kendo-grid-column>

        <!-- Better: define messages in TS and bind [messages]="gridMessages" -->
        <kendo-grid-messages pagerItemsPerPage="{{ '_Items_Per_Page_Text_' | translate }}"
                             pagerFirstPage="{{ '_Go_To_First_Page_Text_' | translate }}"
                             pagerLastPage="{{ '_Go_To_Last_Page_Text_' | translate }}"
                             pagerNextPage="{{ '_Go_To_Next_Page_Text_' | translate }}"
                             pagerPreviousPage="{{ '_Go_To_Previous_Page_Text_' | translate }}"
                             pagerPage="{{ '_Page_Grid_Text_' | translate }}"
                             noRecords="{{ '_NoRecords_Grid_Text_' | translate }}"
                             pagerItems="{{ '_General_Kendo_Grid_Pageable_Items_Text_' | translate }}"
                             pagerOf="{{ '_General_Kendo_Grid_Pageable_Of_Text_' | translate }}">
        </kendo-grid-messages>
      </kendo-grid>
     
    </div>

  </div>
</div>
